import { render } from "./LButtomMenu.vue?vue&type=template&id=68a2e41a&scoped=true&ts=true"
import script from "./LButtomMenu.vue?vue&type=script&lang=ts"
export * from "./LButtomMenu.vue?vue&type=script&lang=ts"

import "./LButtomMenu.vue?vue&type=style&index=0&id=68a2e41a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a2e41a"]])

export default __exports__